import { IPlayer } from '@trackman/baseball-shared-components';
import { makeAutoObservable } from 'mobx';

export enum FilterPosition {
  Pitcher = 'pitcher',
  Catcher = 'catcher',
  Batter = 'batter',
}

export const FilterPositionDict: Record<FilterPosition, string> = {
  [FilterPosition.Pitcher]: 'Pitchers',
  [FilterPosition.Catcher]: 'Catchers',
  [FilterPosition.Batter]: 'Batters',
};

export type PlayerFilter = { label: string; value: string; position: FilterPosition };

export class FilterStore {
  filters: PlayerFilter[] = [];

  isConfiguratorVisible = false;

  placeholderPlayers: IPlayer[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  addPlaceholderPlayerToFilters = (player: IPlayer): void => {
    if (!this.placeholderPlayers.some((p) => p.id === player.id)) {
      this.placeholderPlayers = [...this.placeholderPlayers, player];
    }
  };

  changeConfiguratorVisibility = (value: boolean): void => {
    this.isConfiguratorVisible = value;
  };

  countFilters = (): number => {
    return this.filters.length;
  };

  addPlayerToFilter = (player: Omit<PlayerFilter, 'position'>, position: FilterPosition): void => {
    if (!this.filters.some((p) => p.value === player.value && p.position === position)) {
      this.filters = [...this.filters, { ...player, position }];
    }
  };

  removePlayerFromFilter = (playerId: string, position: FilterPosition): void => {
    this.filters = this.filters.filter((p) => !(p.value === playerId && p.position === position));
  };

  isPlayerInFilter = (playerId: string, position: FilterPosition): boolean => {
    return this.filters.some((p) => p.value === playerId && p.position === position);
  };

  clearFilters = (): void => {
    this.filters = [];
  };

  cleanupStore = (): void => {
    this.filters = [];
    this.isConfiguratorVisible = false;
    this.placeholderPlayers = [];
  };
}
